
import { defineComponent } from 'vue';

import ProgressIndicator from '@/components/ProgressIndicator/ProgressIndicator.vue';
import PoweredBy from '@/components/PoweredBy/PoweredBy.vue';
import { FormControlModel } from 'mq-ui-kit/lib/form-control-model';
import {
  JobManager,
  markAsAlreadyHadAppointment,
  getJobManagers,
  JobManagerWithFunction,
} from '@/services/job-managers.service';

import { Button } from 'mq-ui-kit/lib/Button';
import { FormRow } from 'mq-ui-kit/lib/FormRow';
import { AutoComplete } from 'mq-ui-kit/lib/AutoComplete';
import ToastService from 'mq-ui-kit/lib/toast';
import { Validators } from 'mq-ui-kit/lib/form-validate';
import * as Actions from '@/store/actions';

export default defineComponent({
  name: 'AppointmentContact',

  components: {
    PoweredBy,
    ProgressIndicator,
    Button,
    FormRow,
    AutoComplete,
  },

  data() {
    return {

      contactsFunction: '',
      fullNameOfJobManager: '',
      emailAddressOfEmployee: '',
      enableNextStepButton: false,
      disablePreviousButton: false,
      showLoading: false,
      autoCompleteData: {
        managers: [] as JobManagerWithFunction[],
        itemText: 'fullName',
        itemValue: 'functionTitle',
      },

      jobManager: new FormControlModel({
        validations: [Validators.required()],
        messages: {
          required: 'appointmentContact.jobManagerMandatory',
        },
      }),
    };
  },

  created() {
    this.getJobManagersList();
  },

  methods: {
    getJobManagersList() {
      if (this.$store.state.campaign) {
        this.contactsFunction = this.$store.state.campaign?.contactsFunction as string;
      }

      Promise.all([
        getJobManagers(this.contactsFunction),
        // We always want the contacts with function titles 'CityManager' and 'ProjectManager'
        // to be in the dropdown, because they work all campaigns.
        getJobManagers('CityManager'),
        getJobManagers('ProjectManager'),
      ]).then(([campaignManagers, cityManagers, projectManagers]) => {
        // For each campaign manager, add the function title, because we need to send
        // both the name and the function to the back-end later
        const campaignManagersWithFunction : JobManagerWithFunction[] = campaignManagers
          .map((it) => ({ fullName: it.fullName, function: this.contactsFunction }));
        const cityManagersWithFunction : JobManagerWithFunction[] = cityManagers
          .map((it) => ({ fullName: it.fullName, function: 'CityManager' }));
        const projectManagersWithFunction : JobManagerWithFunction[] = projectManagers
          .map((it) => ({ fullName: it.fullName, function: 'ProjectManager' }));

        // Add al campaign managers as inputs to the dropdown.
        this.autoCompleteData.managers = [
          campaignManagersWithFunction, cityManagersWithFunction, projectManagersWithFunction,
        ].flat();
      }).catch(() => {
        ToastService.errorToast(this, this.$t('appointmentContact.errorJobManagerListLoad'));
      });
    },

    markAsAlreadyHadAppointment() {
      this.showLoading = true;
      this.enableNextStepButton = false;
      this.disablePreviousButton = true;

      if (this.$store.state.yourdata) {
        this.emailAddressOfEmployee = this.$store.state.yourdata.emailAddress;
      }
      markAsAlreadyHadAppointment(
        this.fullNameOfJobManager,
        this.contactsFunction,
        this.emailAddressOfEmployee,
      )
        .then(() => {
          this.$store.dispatch(Actions.SET_APPOINTMENT_REGISTERED_FLAG, true);
          this.goToAppointmentSuccessPage();
        })
        .catch(() => {
          this.$store.dispatch(Actions.SET_APPOINTMENT_REGISTERED_FLAG, false);
          ToastService.errorToast(this, this.$t('appointmentContact.errorRedirectToSuccessPage'));
          this.enableNextStepButton = true;
          this.showLoading = false;
          this.disablePreviousButton = false;
        });
    },

    onJobManagerSelect(jobManagerWithFunction: JobManagerWithFunction) {
      if (jobManagerWithFunction) {
        this.fullNameOfJobManager = jobManagerWithFunction.fullName as string;
        this.contactsFunction = jobManagerWithFunction.function;
        this.enableNextStepButton = true;
        this.disablePreviousButton = false;
      }
    },

    goToAppointmentSuccessPage() {
      this.$router.push({
        name: 'Success',
      });
    },

    goToBackPage() {
      this.$router.go(-1);
    },
  },

});
